import { render, staticRenderFns } from "./BlogRightSidebar.vue?vue&type=template&id=44be6260&"
import script from "./BlogRightSidebar.vue?vue&type=script&lang=js&"
export * from "./BlogRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports